import * as React from 'react';
import PropTypes from 'prop-types';
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
} from '@mui/material';
import { useDispatch } from 'react-redux';
import useLocales from '../../../hooks/useLocales';
import { deleteFTVehicleType, fetchFTVehicleTypes } from '../../../redux/slices/ftVehicleTypesSlice';

FTVehicleTypesDeleteModal.propTypes = {
  passedData: PropTypes.any,
  open: PropTypes.bool,
  handleClose: PropTypes.func,
};

export default function FTVehicleTypesDeleteModal({ passedData, open, handleClose }) {
  const dispatch = useDispatch();
  const { translate } = useLocales();

  const handleDelete = () => {
    dispatch(deleteFTVehicleType({ device: window.navigator.userAgent, id: passedData })).then(() => {
      dispatch(fetchFTVehicleTypes());
    });
    handleClose();
  };

  return (
    <Dialog open={open} onClose={handleClose} aria-labelledby="delete-vehicle-type">
      <DialogTitle id="delete-vehicle-type">{translate('deletePopupTitle')}</DialogTitle>
      <DialogContent>
        <DialogContentText>{translate('deletePopupMessageOneItem')}</DialogContentText>
      </DialogContent>
      <DialogActions>
        <Button variant="outlined" color="primary" autoFocus onClick={handleClose}>
          {translate('cancel')}
        </Button>
        <Button variant="contained" color="error" onClick={handleDelete} autoFocus>
          {translate('delete')}
        </Button>
      </DialogActions>
    </Dialog>
  );
}
